import enCompanyTargets from './en';
import ruCompanyTargets from './ru';

export default {
  en: {
    ...enCompanyTargets,
  },
  ru: {
    ...ruCompanyTargets,
  },
};
